import {
  createAuthClient,
  createAuthService,
} from '@trevize/better-auth/client'

import { getRuntimeConfig } from '#lib/runtime-config.ts'

export const authClient = createAuthClient({
  baseURL: getRuntimeConfig().authOrigin,
})

export const authService = createAuthService(authClient)
